import React, { useCallback, useEffect, useRef, useState } from 'react';

export type OnDrag = (
  x: number,
  y: number,
  e: MouseEvent,
  dragEnd?: boolean
) => void;
interface Props {
  x: number;
  y: number;
  onDrag: OnDrag;
}

export type IStartDrag = (e: React.MouseEvent, x?: number, y?: number) => void;

const useDraggable = (props: Props) => {
  const posRef = useRef({
    diffX: 0,
    diffY: 0,
    // x: props.x,
    // y: props.y,
  });

  const [isMoving, setMovingState] = useState(false);

  // useEffect(() => {
  //   posRef.current.x = props.x;
  //   posRef.current.y = props.y;
  // }, [props.x, props.y]);

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      const x = e.clientX - posRef.current.diffX;
      const y = e.clientY - posRef.current.diffY;

      e.preventDefault();

      requestAnimationFrame(() => props.onDrag(x, y, e));
      // props.onDrag(x, y, e);
    },
    [props.onDrag, posRef]
  );

  const onMouseUp = useCallback(
    (e: MouseEvent) => {
      const x = e.clientX - posRef.current.diffX;
      const y = e.clientY - posRef.current.diffY;

      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      props.onDrag(x, y, e, true);
      // if (props.onMoveEnd) props.onMoveEnd(x, y);
      setMovingState(false);
    },
    [onMouseMove, props.onDrag]
  );

  const onMouseDown = useCallback(
    (e: React.MouseEvent, x?: number, y?: number) => {
      x = x ?? props.x;
      y = y ?? props.y;

      posRef.current.diffX = e.clientX - x;
      posRef.current.diffY = e.clientY - y;

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);

      // This will prevent focus change
      e.preventDefault();

      setMovingState(true);
    },
    [props.x, props.y, onMouseMove, onMouseUp, props.onDrag]
  );

  return {
    onMouseDown,
    isMoving,
  };
};

export default useDraggable;
